import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IPhoto } from './Photos.types';
import { limit, orderBy, where } from 'firebase/firestore';

@Identifiable
@Timestampable
@Untrackable
export class Photo extends AbstractDocument<IPhoto> {
  readonly collections = {};

  readonly translatable = (data: IPhoto): NonNullable<IPhoto['_translations']>[string] => ({
    label: data.label,
  });
}

export class Photos extends AbstractCollection<Photo, IPhoto> {
  static path = 'photos';

  constructor(document: Supplier) {
    super(document.collection(Photos.path), Photo);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }

  async getByOrder(order: number) {
    return Object.values(await this.query([where('order', '==', order)]).get()).shift();
  }

  async getFirst() {
    return Object.values(await this.query([orderBy('order'), limit(1)]).get()).shift();
  }
}
